import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据UUID查询表单详情
export function queryFormByUuid(data) {
  return request({
    url: URL.sys.queryFormByUuid,
    method: 'post',
    data
  })
}

// 根据条件分页查询表单列表
export function queryFormsByCondition(data) {
  return request({
    url: URL.sys.queryFormsByCondition,
    method: 'post',
    data
  })
}

// 根据UUID列表批量删除表单
export function deleteFormsByUuids(data) {
  return request({
    url: URL.sys.deleteFormsByUuids,
    method: 'delete',
    data
  })
}

// 保存表单
export function saveForm(data) {
  return request({
    url: URL.sys.saveForm,
    method: 'post',
    data
  })
}

// 启用表单
export function enableFormByUuid(data) {
  return request({
    url: URL.sys.enableFormByUuid,
    method: 'post',
    data
  })
}

// 禁用表单
export function disableFormByUuid(params) {
  return request({
    url: URL.sys.disableFormByUuid,
    method: 'post',
    params
  })
}

// 发布表单
export function publishFormByUuid(params) {
  return request({
    url: URL.sys.publishFormByUuid,
    method: 'post',
    params
  })
}

// 复制表单
export function copyFormByUuid(params) {
  return request({
    url: URL.sys.copyFormByUuid,
    method: 'post',
    params
  })
}

// 查询表单版本列表
export function queryFormRevisions(data) {
  return request({
    url: URL.sys.queryFormRevisions,
    method: 'post',
    data
  })
}

// 恢复表单版本
export function restoreFormRevision(params) {
  return request({
    url: URL.sys.restoreFormRevision,
    method: 'post',
    params
  })
}

// AI检测函数
export function analyzerDetectFunction(data) {
  return request({
    url: URL.sys.analyzerDetectFunction,
    method: 'post',
    data
  })
}

// 校验修改订单【自定义表单、沃宝使用】
export function uiCustomCheckUpdateOrder(data) {
  return request({
    url: URL.sys.uiCustomCheckUpdateOrder,
    method: 'post',
    data
  })
}

// 修改订单【自定义表单、沃宝使用】
export function uiCustomUpdateOrder(data) {
  return request({
    url: URL.sys.uiCustomUpdateOrder,
    method: 'post',
    data,
    replaceNull: false
  })
}

// 校验修改订单字段【自定义表单使用】
export function uiCustomCheckUpdateFields(data) {
  return request({
    url: URL.sys.uiCustomCheckUpdateFields,
    method: 'post',
    data,
    replaceNull: false
  })
}

// 修改订单字段返回实体到前端【自定义表单使用，不执行保存】
export function uiCustomUpdateFields(data) {
  return request({
    url: URL.sys.uiCustomUpdateFields,
    method: 'post',
    data,
    replaceNull: false
  })
}

// 保存订单【自定义表单使用】
export function uiCustomSave(data) {
  return request({
    url: URL.sys.uiCustomSave,
    method: 'post',
    data
  })
}

// 根据keys查询表单名称
export function queryUiCustomNameByKeys(keys) {
  return request({
    url: URL.sys.queryUiCustomNameByKeys,
    method: 'post',
    data: keys
  })
}

// 语音识别-开始会话
export function asrStart(data) {
  return request({
    url: URL.sys.asrStart,
    method: 'post',
    data
  })
}

// 语音识别-发送音频数据
export function asrAudio(data) {
  return request({
    url: URL.sys.asrAudio,
    method: 'post',
    data
  })
}

// 语音识别-结束会话
export function asrFinish(data) {
  return request({
    url: URL.sys.asrFinish,
    method: 'post',
    data
  })
}
